import { getBrandId } from '../helpers/getBrandId/getBrandId';

export enum QueryKeys {
  item = 'item',
  blob = 'blob',
  itemModifierGroups = 'itemModifierGroups',
  items = 'items',
  productSizes = 'productSizes',
  optionGroups = 'optionGroups',
  menu = 'menu',
  menus = 'menus',
  inventory = 'inventory',
  inventoryItem = 'inventoryItem',
  ranges = 'ranges',
  librarySyncStatus = 'librarySyncStatus',
  venueSyncStatus = 'venueSyncStatus',
  notifications = 'notifications',
  productPrices = 'productPrices',
  venues = 'venues',
  venueCategories = 'venueCategories',
  priceBands = 'priceBands',
  priceRules = 'priceRules',
  priceSchemes = 'priceSchemes',
  externalSystems = 'externalSystems',
  events = 'events',
  pricingCategories = 'pricingCategories',
  schedules = 'schedules',
  publishHistory = 'publishHistory',
  validationReport = 'validationReport',
  timetables = 'timetables',
  timetable = 'timetable',
  menuSets = 'menuSets',
  ingestDiff = 'ingestDiff',
}

export const SYNC_STATUS_QUERY = [getBrandId(), QueryKeys.librarySyncStatus];
export const VENUE_SYNC_STATUS_QUERY = [getBrandId(), QueryKeys.venueSyncStatus];
export const NOTIFICATIONS_QUERY = [getBrandId(), QueryKeys.notifications];
export const PRICE_RULES_QUERY = [getBrandId(), QueryKeys.priceRules];

export const getIngestDiffQueryKey = (eventId?: string) => [getBrandId(), QueryKeys.ingestDiff, eventId];
